<template>
  <div class="demo-app" :class="{ active: this.demoActive == true }">
    <!-- <pre> {{schedulingList}}</pre>  -->
<!-- {{name}} -->
    <div class="flex items-start w-full">
      <!-- {{CalendarApi}} -->
      <!-- {{name}} -->
      <vs-card class="demo-app-sidebar">
        <button @click="openMenubar" class="nav-btn">
          <span class="material-icons">chevron_right</span>
        </button>
        <div class="leftSidebarContent">
          <!--  <div class="childInherit">
            <vs-input
              class="inputx w-full"
              placeholder="Search"
              v-model="search"
            />
          </div> -->

          <!-- <strong class="block text-lg my-2">{{ name }}</strong> -->
          <strong class="block text-lg my-2">Cancelled Schedule</strong>
          <!-- {{course_filter_id}} -->
          <!-- {{courseList}} -->
          <v-select
            append-to-body
            class="w-full"
            label="name"
            v-model="course_filter_id"
            :clearable="false"
            :options="courseList"
            :multiple="true"
            :reduce="item=>item.id"
            placeholder="Enter Course Name"
          ></v-select>
          <ul class="leftx name-list p-0">
            <!-- <li class="modelx">{{ name }}</li> -->
            <!-- {{radios1}} -->
            <!-- <pre>{{teacherList}}</pre> -->
            <li class="relative">
              <vs-checkbox
                v-if="teacherList.length"
                v-model="allTeachers"
                @change="filterAllTeacher"
                >All Teachers</vs-checkbox
              >
              <span v-else>No Teacher</span>
            </li>
            <li
              class="relative"
              v-for="(eachTeacher, index) in teacherList"
              :key="index"
            >
              <!-- <pre>{{eachTeacher}}</pre> -->
              <vs-checkbox
                v-model="eachTeacher.isActive"
                @change="filterTeacherEvent()"
                :color="eachTeacher.colour_code"
              >
                <!-- {{eachTeacher.colour_code}} -->
                <div class="img-holder">
                  <!-- {{eachTeacher.user.user_organization_mapping[0].picture}} -->
                  <img
                    v-if="eachTeacher.picture"
                    :src="eachTeacher.picture"
                    alt="user-img"
                    width="40"
                    height="40"
                    class="rounded-full shadow-md cursor-pointer block"/>
                  <img
                    v-else
                    src="https://st4.depositphotos.com/4329009/19956/v/600/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg"
                    alt="user-img"
                    width="40"
                    height="40"
                    class="rounded-full shadow-md cursor-pointer block"/>
                </div>
                <span class="pl-14 inline-block">
                  {{ eachTeacher.user.first_name }}
                  {{ eachTeacher.user.last_name }}</span
                ></vs-checkbox
              >
            </li>
          </ul>
        </div>
      </vs-card>

      <div class="demo-app-main">
        <vs-card>
          <!-- <pre>{{arg}}</pre>  -->
          <FullCalendar
            class="demo-app-calendar"
            :options="calendarOptions"
            ref="calendar"
          >
            <!-- Hello -->
            <template v-slot:eventContent="arg">
              <div class="w-full" v-if="arg">
                <!-- <pre>{{arg.event.extendedProps.cstmcolor}}</pre> -->
                <vs-tooltip :text="arg.event.title">
                  <!-- <div class="flex items-center p-1 event-card" :style="{backgroundColor:arg.event.backgroundColor, color:arg.event.extendedProps.cstmcolor}"> -->
                  <div class="event-card">
                    <!-- <img
                      src="/img/avatar-s-11.1a620230.jpg"
                      alt="user-img"
                      width="40"
                      height="40"
                      class="rounded-full shadow-md block mr-1"
                    /> -->
                    <div class="flex items-center">
                      <div
                        class="indicator"
                        :style="{ backgroundColor: arg.event.backgroundColor }"
                      ></div>

                      <!-- <feather-icon icon="ClockIcon" /> -->
                      <b>{{ arg.timeText }}</b>
                      <!-- <feather-icon icon="UserIcon" /> -->
                      <b class="limitTitle"
                        ><i>{{ arg.event.title }}</i></b
                      >
                      <p>
                        <i>{{ arg.location }}</i>
                      </p>
                    </div>
                  </div>
                </vs-tooltip>
              </div>
            </template>

            <!-- <template #eventContent="{ timeText, event }">
                     <pre></pre>
                    <b>{{ timeText }}</b>
                    <i>{{ event.title }}</i>
                </template> -->
          </FullCalendar>
        </vs-card>
      </div>
    </div>
    <!-- edit modal -->
    <div v-if="eachEventInfo">
      <!-- <vs-popup
        class="holamundo"
        :title="eachEventInfo.title"
        :active.sync="eachEventPopUp"
      > -->
        <!-- <pre>{{event}}</pre> -->
        <!-- <event-detail :eachEventInfo="eachEventInfo"></event-detail>
      </vs-popup> -->
      <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup schedule-popup" v-if="eachEventPopUp" :class="{show: eachEventPopUp}">
        <div style="max-width: 845px;" class="cstm-modal">
          <div class="header">
            <!-- <pre>{{eachEventInfo.extendedProps.course.course}}</pre> -->
          <!-- <div class="header" :style="{'background-color': eachEventInfo.backgroundColor}"> -->
            <!-- <h3 :style="{'color':getContrast(eachEventInfo.backgroundColor)}">{{eachEventInfo.title}}</h3> --> 
            <img v-if="eachEventInfo.extendedProps.course.courseImage === null" src= "https://scoolio-alpha.s3.eu-west-2.amazonaws.com/default_course_image.png" style="width: 100%; height: 200px; object-fit: contain;" />
            <img v-else :src= "eachEventInfo.extendedProps.course.courseImage.file.file_path" style="width: 100%; height: 200px; object-fit: contain;" />
            <button @click="eachEventPopUp = false" class="close-modal">&times;</button>
          </div>
          <!-- <pre>{{eachEventInfo.backgroundColor}}</pre> -->
          <div class="modal-content">
            <event-detail :eachEventInfo="eachEventInfo"
            :name="name"
            @editedSchedule="updatedObject"
            @enrolledUser="updatedObject"
            ></event-detail>

          </div>
        </div>
      </div>
    </div>

    <!-- adding event modal -->
    <div v-if="eventAdding">
      <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-show="eventAdding" :class="{show: eventAdding}">
        <div class="cstm-modal">
          <div class="header">
            <h3>Add Event</h3>
            <button @click="eventAdding = false" class="close-modal">&times;</button>
          </div>
          <div class="modal-content">
            <add-event
              @createEvent="createEvent"
              :startDate="startDate"
              :endDate="endDate"
            ></add-event>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { INITIAL_EVENTS, createEventId } from './event-utils'
import ListPlugin from '@fullcalendar/list'
import Datepicker from 'vuejs-datepicker'
import AddEvent from './components/AddEvent'
import Testing from './components/Testing'

import EventDetail from './components/EventDetail'
import Editor from '@tinymce/tinymce-vue'
import { eventMixin } from './mixins/eventMixin'
import vSelect from 'vue-select'

import Vue from 'vue'
export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    AddEvent,
    Datepicker,
    EventDetail,
    editor: Editor,
    Testing,
    vSelect
  },
  mixins: [eventMixin],
  props: {
    name: {
      type: String,
      required: true
    }
  },
  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API
    /*  this.radios1.fill('add', 0, 10)
    for (let i = 0; i < 10; i++) {

      this.radios1.push(false)
    } */
    this.fetchingTeacherList()
    this.fetchCourseWithList()

    this.fetchingEvent(null, 'cancel')
  },
  mounted () {
    this.calendarApi = this.$refs.calendar.getApi()


    //this.$refs.calendar.getApi().prev()


    //
    //

    //

    /*    const moreElement = document.getElementsByClassName('fc-daygrid-more-link')


    moreElement[0].addEventListener('click', event => {
      event.stopPropagation()

      //

    }) */

    //inserting Component // Very
    /*  const vuecomp = Vue.extend(Testing)
    const component = new vuecomp().$mount()

    // this.$refs.calendar.$el.firstChild.append(component.$el)


    this.$refs.calendar.$el.firstChild.parentNode.insertBefore(component.$el, this.$refs.calendar.$el.firstChild.nextSibling) */

    //inserting component//
  },
  data () {
    return {
      search: 'sad',
      event: null,
      startDate: null,
      endDate: null,
      eachEventPopUp: false,
      eventAdding: false,
      title: '',
      picked: 1,
      // radios1: [],
      eachEventInfo: null,
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          ListPlugin // needed for dateClick
        ],
        customButtons: {
          previousButton: {
            text: '<',
            click: () => {
              this.previousMonth('cancel')
            }
          },
          nextButton: {
            text: '>',
            click: () => {
              this.nextMonth('cancel')
            }
          },
          todayButton: {
            text: 'Today',
            click: () => {
              this.today('cancel')
            }
          }
        },
        firstDay: 1,

        headerToolbar: {
          left: 'previousButton,nextButton todayButton',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
        },
        eventLimit: false, // for all non-TimeGrid views
        events: [],
        initialView: 'dayGridMonth',
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        eventTimeFormat: {
          // like '14:30'
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false
        },
        // INITIAL_EVENTS:this.events,
        weekends: true,
        // select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        eventDrop: (info) => {
          this.eventDrop(info)
        }
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      currentEvents: [],
      demoActive: false,
      schedulingList: [],
      eachMonthEventData: [],
      calendarApi: '',
      allTeachers: true
    }
  },
  methods: {
    updatedObject (fromWhere) {
      this.eachEventPopUp = false

      const payload = this.creatingPayload('teacher')
      this.fetchingEvent(payload, 'cancel')
      if (fromWhere === 'Cancel') {
        this.showSuccessMessage('Success', 'Schedule cancelled successfully', 'success')
      } else if (fromWhere === 'Link') {
        this.showSuccessMessage('Success', 'Link updated successfully', 'success')
      }

    },
    eventDrop (info) {

      // info.revert()
      // alert(`${info.event.title  } was dropped on ${  info.event.start.toISOString()}`)

      /*  if (!confirm('Are you sure about this change?')) {
        info.revert()
      } */

    },
    /*  previousMonth () {
      this.calendarApi.prev()
      const payload = this.creatingPayload()
      this.fetchingEvent(payload)

    },
    creatingPayload () {

      const year = this.calendarApi.getDate().getFullYear()
      const month = this.calendarApi.getDate().getMonth() + 1  //jan = 0
      const monthString = String(month).padStart(2, 0)  // 0009
      return {
        // user_id: [],
        year,
        month: monthString
        // type:'teacher'
      }
    },
    nextMonth () {

      this.calendarApi.next()
      const payload = this.creatingPayload()
      this.fetchingEvent(payload)
    },
    today () {

      this.calendarApi.today()
      const payload = this.creatingPayload()
      this.fetchingEvent(payload)
    }, */
    handleMonthChange (arg) {

    },
    changeMonth (start, end) {

    },


    // getContrast (hexcolor) {
    //   //
    //   hexcolor = hexcolor.replace('#', '')
    //   const r = parseInt(hexcolor.substr(0, 2), 16)
    //   const g = parseInt(hexcolor.substr(2, 2), 16)
    //   const b = parseInt(hexcolor.substr(4, 2), 16)
    //   const yiq = (r * 299 + g * 587 + b * 114) / 1000
    //   return yiq >= 128 ? '#000000' : '#ffffff'
    // },
    handleWeekendsToggle () {
      this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
    },
    handleDateSelect (selectInfo) {

      this.startDate = selectInfo.startStr
      this.endDate = selectInfo.endStr
      //
      this.eventAdding = true
      // const title = prompt('Please enter a new title for your event')
      // const calendarApi = selectInfo.view.calendar
      //
      // calendarApi.unselect() // clear date selection
      // if (title) {
      //   calendarApi.addEvent({
      //     id: 1,
      //     title,
      //     start: new Date().toISOString().replace(/T.*$/, ''),
      //     end: new Date().toISOString().replace(/T.*$/, ''),
      //     allDay: false
      //   })
      // }
    },
    handleEventClick (clickInfo) {

      this.eachEventInfo = clickInfo.event
      this.eachEventPopUp = true

      //
      // this.event = clickInfo.event
      //
      // const refs = this.$refs.fullCalendar.getEvents()
      //
      // if (
      //   confirm(
      //     `Are you sure you want to delete the event '${clickInfo.event.title}'`
      //   )
      // ) {
      //   clickInfo.event.remove()
      // }
    },
    handleEvents (events) {
      this.currentEvents = events
    },
    createEvent (obj) {
      //


      INITIAL_EVENTS.push({
        id: createEventId(),
        title: obj.title,
        start: `${obj.course_start} ${obj.course_start_time}`,
        // startTime: obj.course_start_time,
        end: `${obj.course_end} ${obj.course_end_time}`,
        backgroundColor: obj.eventTextColor,
        location: obj.location,
        eventTypePicked: obj.eventTypePicked
      })


      this.showSuccessMessage('Success', 'Event Added Successfully', 'success')
      setTimeout(() => {
        this.eventAdding = false
      }, 0)
      /*   setTimeout(() => {
        this.eventAdding = false

      }, 1000) */

      // this.$refs.calendar.$emit('refetch-events')
    },
    openMenubar () {
      this.demoActive = !this.demoActive
    }
  },
  watch:{
    course_filter_id:{
      deep:true,
      handler () {

        this.fetchingTeacherList(this.course_filter_id, 'true')
      }
    }
  }
}
</script>

<style lang='css'>
h2 {
  margin: 0;
  font-size: 16px;
}
/* ul {
  margin: 0;
  padding: 0 0 0 1.5em;
}
li {
  margin: 1.5em 0;
  padding: 0;
} */
b {
  /* used for event dates/times */
  /* margin-right: 3px; */
}
.fc {
  /* the calendar root */
  max-width: 100%;
}
.childInherit {
  width: inherit;
}

.teacher-info {
  display: inherit;
  min-width: 50%;
  border: 1px solid #eee;
  padding: 10px;
}
.bg-light-grey {
  background: #f3f3f3;
  padding: 5px;
  margin: 0 5px;
  border-radius: 5px;
}
.tox-tinymce-aux {
  z-index: 100000 !important;
}

.event-card {
  border-radius: 4px;
  /* background-color: #41ccdf;
  color: #fff;
  border-width: 3px 0 0 0;
  border-style: solid;
  border-color: transparent; */
}
/* .fc-event-today {
  border: none;
  background-color: transparent;
}
.fc-event-today .event-card {
  background-color: #ccc;
}
.fc-event-today .indicator {
  display: none;
} */
.event-card .feather-icon {
  width: 12px;
  margin-right: 2px;
}
.event-card .limitTitle {
  display: inline-block;
  width: calc(100% - 45px);
  overflow: hidden;
  text-overflow: ellipsis;
}
.indicator {
  width: 7px;
  height: 7px;
  margin-right: 3px;
  border-radius: 50%;
}

/* td.fc-daygrid-day {
  height: 200px;
} */

@media (max-width: 480px) {
  .teacher-info {
    min-width: 100%;
  }
}
</style>

